import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  callExChangeRate,
  callGetCategories,
  callGetShipping,
  callGetThemes,
  getOrders,
  getProductDetail,
  searchProduct
} from '../../helpers/api_helper';

export const searchProductAPI = createAsyncThunk(
  'ecommerce/searchProducts',
  async (params?: any) => {
    try {
      const response = searchProduct(params);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getProductDetailAPI = createAsyncThunk(
  'ecommerce/getProductDetailAPI',
  async ({ id, provider }: any) => {
    try {
      const response = getProductDetail(id, provider);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const exChangeRateAPI = createAsyncThunk(
  'ecommerce/exChangeRate',
  async () => {
    try {
      const response = callExChangeRate();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getOrdersAPI = createAsyncThunk(
  'ecommerce/getOrders',
  async (params: any) => {
    try {
      const response = getOrders(params);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getCategories = createAsyncThunk(
  'ecommerce/getCategories',
  async () => {
    try {
      const response = callGetCategories();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getThemes = createAsyncThunk('ecommerce/getThemes', async () => {
  try {
    const response = callGetThemes();
    return response;
  } catch (error) {
    return error;
  }
});

export const getShipping = createAsyncThunk('ecommerce/getShipping', async () => {
  try {
    const response = callGetShipping();
    return response;
  } catch (error) {
    return error;
  }
});

